module.exports = __webpack_public_path__ + "img/Flohmarkt.878ea750.jpg";